/**
 * Компонент Icon дизайн-системы читает набор иконок из window.lucide.
 * В дизайн-системе набор подключается тегом script с CDN; здесь тот же самый
 * пакет ставится из npm и кладётся в то же место, чтобы не править компонент
 * и не зависеть от внешней сети при каждом запуске.
 * Допущение зафиксировано в docs/14-open-questions.md.
 */
import { icons } from 'lucide';

declare global {
  interface Window {
    lucide?: { icons: typeof icons };
  }
}

export function installLucideIcons(): void {
  window.lucide = { icons };
}
